import { Sector } from './sector';

export class SectorList {
  commonSectors: Sector[];
  popularSectors: Sector[];
}
